export const HOME = "/home"
export const SIGN_IN = "/login"
export const ACCOUNT = "/account"
export const EVENTS = "/events"
export const CREATE_EVENT = "/create-event"
export const CONTACT = "/contact"
export const EVENT_DETAIL = "/event-detail/:id"
export const EVENT_CREATED = "/event-created"
export const EDIT_EVENT = "/edit-event"
export const EVENT_CHANGED = "/event-changed"
export const ADDED_SUCCESSFULLY = "/added-successfully"